<template>
  <v-dialog v-model="dialog" max-width="500px" transition="dialog-transition">
    <template persistent v-slot:activator="{ attrs, on }">
      <!-- v-on="on" -->
      <v-btn
        small
        color="success"
        v-bind="attrs"
        :loading="isloading"
        v-on="on"
        icon
      >
        <v-icon>fas fa-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline justify-center"
        >Add New Qaas
        <v-spacer></v-spacer>
        <v-btn v-if="!isloading" text icon color="primary" @click="Close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="font-weight-black title text-center">
        <v-text-field
          outlined
          label="Qass Account Number"
          v-model.trim="AccountNumber"
          :rules="[QaasRule]"
          append-icon="fas fa-user-tie"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="!chekRul"
          :loading="isloading"
          class="elevation-6"
          @click="AddQaas"
          rounded
          color=""
          dark
          block
          >Save Qaas {{ chekRul }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    supp: { type: Object, required: true },
    onFinish: { type: Function, default: () => null },
  },
  data() {
    return {
      ReqURL: "/supplier/qaas",
      dialog: false,
      isloading: false,
      AccountNumber: "",
    };
  },
  computed: {
    chekRul() {
      return typeof this.QaasRule(this.AccountNumber) === "boolean";
    },
  },
  methods: {
    QaasRule(v) {
      if (!v) return "required";
      if (!v.match(`^QAS${this.supp.type}-`))
        return "This Account is not correct.";
      return true;
    },
    Close() {
      if (!this.isloading) {
        this.AccountNumber = "";
        this.dialog = false;
      }
    },
    AddQaas() {
      this.isloading = true;
      //   console.log(this.QaasRule(this.AccountNumber));
      //   if (typeof this.QaasRule(this.AccountNumber) === "string") return;
      this.$store
        .dispatch("INSERT_ONLY", {
          url: this.ReqURL,
          data: {
            _id: this.supp._id,
            oldQaas: this.supp.qaas,
            qaas: this.AccountNumber,
          },
        })
        .then(() => {
          this.dialog = true;
          this.isloading = false;
          this.onFinish(true);
          this.Close();
          //   this.QaasList = result.data;
        })
        .catch(() => {
          // console.log(error);
          //   this.clickedID = "";
          this.isloading = false;
        });
    },
  },
};
</script>
